import { useMantineColorScheme, Group, Switch } from "@mantine/core";
import { IconSun, IconMoonStars } from "@tabler/icons-react";

function ThemeToggle() {
    const { colorScheme, setColorScheme } = useMantineColorScheme();
    const isDark = colorScheme === "dark";
  
    return (
      <Group>
        <Switch
          checked={isDark}
          onChange={(event) => setColorScheme(event.currentTarget.checked ? "dark" : "light")}
          onLabel={<IconSun size={16} stroke={2.5} color="var(--mantine-color-yellow-4)" />}
          offLabel={<IconMoonStars size={16} stroke={2.5} color="var(--mantine-color-blue-6)" />}
          size="md"
          color="rgba(0, 0, 0, 0.51)"
        />
      </Group>
    );
}

export default ThemeToggle;